import React, { useEffect } from "react";

/**
 * ───────────────────────────────────────────────────────────────
 *  📸 INSTAGRAM GALLERY — INSTRUCCIONES PARA MEL
 * ───────────────────────────────────────────────────────────────
 *  Para que aparezcan tus posts reales:
 *  1. Abre tu post en Instagram (instagram.com/dailydossis)
 *  2. Click en los "..." del post → "Embed"
 *  3. Copia SOLO la URL del post (ej: https://www.instagram.com/p/ABC123/)
 *  4. Pégala en el array `posts` de abajo, reemplazando los placeholders
 *  5. Recomendado: 6 posts para que la grid se vea balanceada
 *
 *  Tip: Usa los Reels y posts más trending. Los videos también funcionan.
 * ───────────────────────────────────────────────────────────────
 */
const posts = [
	"https://www.instagram.com/p/DWsBRF2FSFk/",
	"https://www.instagram.com/p/DXvE6GjAd6r/",
	"https://www.instagram.com/reel/DW7cwH1geAk/",
	"https://www.instagram.com/p/DRaBeiVDGZh/",
	"https://www.instagram.com/p/DP4EdvaCkUv/",
	"https://www.instagram.com/p/DRSZ-iqCsFB/",
];

const InstagramGallery = () => {
	// Carga el script oficial de Instagram para que los embeds se rendericen
	useEffect(() => {
		const existing = document.querySelector(
			'script[src="//www.instagram.com/embed.js"]',
		);
		if (!existing) {
			const script = document.createElement("script");
			script.src = "//www.instagram.com/embed.js";
			script.async = true;
			document.body.appendChild(script);
		} else if (window.instgrm) {
			window.instgrm.Embeds.process();
		}
	}, []);

	return (
		<section className="ig-gallery" id="instagram">
			<div className="container">
				<div className="section-header">
					<span className="section-tag">on the 'gram</span>
					<h2 className="section-title">
						living that{" "}
						<span className="text-accent">dossis life</span>
					</h2>
					<p className="section-subtitle">
						síguenos en{" "}
						<a
							href="https://www.instagram.com/dailydossis/"
							target="_blank"
							rel="noopener noreferrer"
							className="ig-gallery__handle"
						>
							@dailydossis
						</a>{" "}
						para los drops nuevos, behind the scenes y mucho coffee
						content
					</p>
				</div>

				<div className="ig-gallery__grid">
					{posts.map((url, i) => (
						<div className="ig-gallery__item" key={i}>
							<blockquote
								className="instagram-media"
								data-instgrm-permalink={url}
								data-instgrm-version="14"
								style={{
									background: "#FFF",
									border: 0,
									borderRadius: "16px",
									boxShadow: "0 8px 24px rgba(0,0,0,0.10)",
									margin: 0,
									maxWidth: "100%",
									minWidth: "280px",
									padding: 0,
									width: "100%",
								}}
							>
								<a
									href={url}
									target="_blank"
									rel="noopener noreferrer"
								>
									Ver post de Dossis en Instagram
								</a>
							</blockquote>
						</div>
					))}
				</div>

				<div className="ig-gallery__cta">
					<a
						href="https://www.instagram.com/dailydossis/"
						target="_blank"
						rel="noopener noreferrer"
						className="btn btn--orange"
					>
						follow @dailydossis
					</a>
				</div>
			</div>
		</section>
	);
};

export default InstagramGallery;
